export var DEFAULT_ITEM_CLASS_NAME = 'continuous-scroll-item';